import {
  ErrorCard,
  IconButton,
  TransWithDefault,
} from '@starsoft/common/components';
import styles from './styles.module.scss';
import { useGamesBySlugWithQueryParams } from '@/hooks/games/useGamesBySlugWithQueryParams';
import Link from '@/components/core/Link';
import { useCallback, useMemo, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import SlotsGameContentGameDetailsSkeleton from './Skeleton';
import { useToggle } from '@starsoft/common/hooks';
import { Collapse } from '@mui/material';
import GameDetailsStatistics from './Statistics';
import GameDetailsTabs from './Tabs';
import { GameDetailsTabsOptions } from './Tabs/props';
import GameDetailsContentRender from './Content';

export default function SlotsGameContentGameDetails() {
  const { t } = useTranslation('game-tag');
  const [open, toggleOpen] = useToggle(false);
  const [current, setCurrent] = useState<GameDetailsTabsOptions>(
    GameDetailsTabsOptions.HighWin,
  );

  const {
    game,
    isLoading: isLoadingGameData,
    error,
    refetch,
  } = useGamesBySlugWithQueryParams();

  const Chips = useMemo(
    () =>
      game?.tags
        ?.filter((_, index) => index < 3)
        ?.map(tag => (
          <Link
            href={`/games/tag/${tag?.tag?.slug}`}
            key={`game-chip-${tag?.id}`}
            className={styles.card__chips__chip}
          >
            {`# ${t(`game-tag:${tag?.tag?.id}.name`)}`}
          </Link>
        )),
    [game, t],
  );

  const onTabChange = useCallback((tab: GameDetailsTabsOptions) => {
    setCurrent(tab);
  }, []);

  if (error) {
    return <ErrorCard refetch={refetch} error={error} />;
  }

  if (isLoadingGameData) {
    return <SlotsGameContentGameDetailsSkeleton />;
  }

  return (
    <div className={styles.card}>
      <div className={styles.card__wrapper}>
        <div
          className={`${styles.card__wrapper} ${styles['card__wrapper--col']}`}
        >
          <div className={styles.card__column}>
            <div className={styles.card__column__title}>{game?.name}</div>
            <div className={styles.card__column__description}>
              <TransWithDefault
                i18nKey="common:by_provider"
                values={{
                  provider: game?.provider?.name,
                }}
                components={{
                  a: <Link href={`/games/providers/${game?.provider?.slug}`} />,
                }}
              />
            </div>
          </div>
          <div className={styles.card__chips}>{Chips}</div>
        </div>
        <IconButton onClick={toggleOpen}>
          <i className={`fa-solid fa-chevron-${open ? 'up' : 'down'}`} />
        </IconButton>
      </div>
      <Collapse in={open}>
        <div className={styles.card__content}>
          <GameDetailsStatistics />
          <GameDetailsTabs current={current} onTabChange={onTabChange} />
          <GameDetailsContentRender current={current} />
        </div>
      </Collapse>
    </div>
  );
}
